import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { Router, RouterLink } from '@angular/router';
import { CurrentUserService } from '@core/auth/current-user.service';
import { NavMenu, buildNavSections } from '../nav';
import { NavIcon } from '../nav-icon/nav-icon';

/**
 * Навигационная панель сайдбара: разделы и ссылки. Список берётся из
 * `data.nav` маршрутов приложения, поэтому отдельные данные ему не передаются.
 */
@Component({
    selector: 'app-sidebar-nav',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { '[class.sidebar-nav--collapsed]': 'collapsed()' },
    imports: [MatTooltip, NavIcon, RouterLink],
    templateUrl: './sidebar-nav.html',
    styleUrl: './sidebar-nav.scss',
})
export class SidebarNav {
    private readonly router = inject(Router);
    private readonly currentUser = inject(CurrentUserService);

    readonly collapsed = input(false);

    protected readonly menu = computed<NavMenu>(() =>
        buildNavSections(this.router.config, (roles) => this.currentUser.hasAnyRole(roles)),
    );
}
